import React from "react";

import styles from "./Authentication.module.css";

import AuthenticationPrompt from "./AuthenticationPrompt";
import AuthenticationButton from "./AuthenticationButton";
import AuthenticationRedirectPrompt from "./LoginOrRegisterPrompt";

const PolicyLink = ({ policyName, policyLink }) => {
  return (
    <a
      href={policyLink}
      className="text-sm font-normal text-neutral-500 hover:text-blue-800 hover:font-normal cursor-pointer duration-150"
      rel="noopener noreferrer"
      target="_blank"
    >
      {policyName}
    </a>
  );
};

const AuthenticationCard = ({
  AuthenticationPromptTitle,
  AuthenticationPromptText,
  AuthenticationButtonPrompt,
  AuthenticationButtonFunction,
  redirectOption,
  children,
}) => {
  return (
    <div
      className={
        styles["background"] +
        " " +
        "flex flex-col items-center justify-start md:justify-center min-h-screen min-w-full"
      }
    >
      {/* Gradient to transition on mobile */}
      <div className="md:hidden sticky top-0 w-full h-8 bg-gradient-to-b from-0% to-100% from-white Xbg-green-500" />
      <div className="flex flex-col items-center justify-center pt-24 md:pt-10 md:pb-10 Xbg-red-500">
        <div>
          <div
            className="flex flex-col bg-white rounded-xl items-center justify-center
           w-[95vw] sm:w-[500px]
           border border-1 border-neutral-300 overflow-hidden
           m-0 sm:m-5
          "
          >
            <div className="flex flex-col bg-neutral-400 w-full rounded-b-xl items-center justify-center py-10">
              <div className="text-6xl text-white">Dermi.ai</div>
            </div>
            {/* White container */}
            <div className="flex flex-col w-full h-full items-center justify-center p-5">
              {/* Authentication information */}
              <AuthenticationPrompt
                title={AuthenticationPromptTitle}
                prompt={AuthenticationPromptText}
              />
              {/* Children components */}
              {children}
              {AuthenticationButtonPrompt && AuthenticationButtonFunction && (
                <AuthenticationButton
                  buttonPrompt={AuthenticationButtonPrompt}
                  onClickFunction={AuthenticationButtonFunction}
                />
              )}
            </div>
          </div>

          {redirectOption && (
            <AuthenticationRedirectPrompt option={redirectOption} />
          )}

          <div className="flex flex-row items-center justify-center w-full py-5 space-x-5 Xbg-red-500">
            <PolicyLink
              policyName={"Terms"}
              policyLink={"https://dermi.ai/terms"}
            />
            <p className="text-sm font-normal text-neutral-500">|</p>
            <PolicyLink
              policyName={"Privacy"}
              policyLink={"https://dermi.ai/privacy-policy"}
            />
            <p className="text-sm font-normal text-neutral-500">|</p>
            <PolicyLink
              policyName={"Disclaimer"}
              policyLink={"https://dermi.ai/clinical-dashboard-disclaimer"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthenticationCard;
